import { render, staticRenderFns } from "./ProfilePlayerStatusEditor.vue?vue&type=template&id=126462d6&"
import script from "./ProfilePlayerStatusEditor.vue?vue&type=script&lang=js&"
export * from "./ProfilePlayerStatusEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports